import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import ConfirmGajiKaryawan from "../../componen/gajiKaryawan/confirmGajiKaryawan";

export const ConfirmGajiKaryawanPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate("/", { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
      <ConfirmGajiKaryawan />
    </Layout>
  );
};
